import React, { FC } from 'react'
import { Shared } from 'ui/shared/index'
import { TObject } from 'utils/types'
import { useRole } from 'ui/shared/Role/Role-ViewModel'

interface IProps {
  /**
   * required if you store ids through  redux or useState
   */
  onClick?: (value: number) => void
  selectedId?: number

  /**
   * required if selected ids stored in react-form-hook
   */
  control?: any
  /**
   * required if selected ids stored in react-form-hook
   */
  error?: null | string
  rules?: any
  name?: string
  className?: string
  divider?: boolean
  hideBorder?: boolean
  style?: TObject
  label?: string
  showTitle?: boolean
  type?: 'form' | 'card'
  title?: string
}

/**
 react-form-hook example
 <Shared.Role
  control={control}
  watch={watch}
 />

 state example
 <Shared.Role
  onClick={onClick}
  isSelected={isSelected}
 />
 */
const Role: FC<IProps> = ({
  className,
  onClick,
  style,
  hideBorder = true,
  divider = true,
  showTitle = true,
  type = 'card',
  label,
  control,
  selectedId,
  error,
  rules,
  name = 'role',
  title = 'Role',
}) => {
  const vm = useRole()

  return (
    <div className={className} style={style}>
      {showTitle && <Shared.CardTitle title={title} divider={divider} />}
      <Shared.Dropdown
        marginTop={type === 'card' ? 16 : '1.5em'}
        control={control}
        name={name}
        options={vm.options}
        onChange={onClick}
        fullWidth
        hideBorder={hideBorder}
        label={label}
        value={selectedId}
        error={error}
        rules={rules}
        isItemCapitalize={true}
      />
    </div>
  )
}

export default React.memo(Role)
